import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  normalize(e) {
    const {
      target: {
        dataset: {
          platformKey
        },
        value,
      }
    } = e
    
    switch (platformKey) {
      case 'youtube':
        // https://youtu.be/aQuu_-R2Pwg
        // https://www.youtube.com/watch?v=aQuu_-R2Pwg
        // YOUTUBE_ID = aQuu_-R2Pwg
        const youtubeRegex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([A-Za-z0-9\-\_]+)/

        const match = value.match(youtubeRegex)
        if (match) {
          e.target.value = match[1]
        }
        break
      default:
        console.log('unknown platform', platformKey)
    }
  }
}
